export const API_URL =
  import.meta.env.VITE_API_URL ?? "http://localhost:8080/api";

export const FALLBACK_ERROR_MESSAGE = "Something went wrong, please try again";

export const NO_PERM_ERROR_MESSAGE =
  "You don't have permissions to access this resource";

export const SD_EMAIL = "support@vibedeploy.dev";
export const FEATURE_EMAIL = "feature@vibedeploy.dev";

export const STATUS_URL = "";

export const FREE_PLAN_SUMMARY_LIMIT = 5;

export const FREE_PLAN_GRAMMAR_LIMIT = 3;
export const FREE_PLAN_GRAMMAR_TEXT_LIMIT = 500;
export const PRO_PLAN_GRAMMAR_TEXT_LIMIT = 10000;

export const FREE_PLAN_PARAPHRASE_LIMIT = 3;
export const FREE_PLAN_PARAPHRASE_TEXT_LIMIT = 500;
export const PRO_PLAN_PARAPHRASE_TEXT_LIMIT = 10000;

export const FREE_PLAN_CV_JOB_DESCRIPTION_LIMIT = 300;

export const API_DEFAULT_LIMIT = 12;

export const FREE_PLAN_NAME = "Free";
export const PRO_PLAN_NAME = "Professional";
export const ENTERPRISE_PLAN_NAME = "Enterprise";

export const APP_URL = import.meta.env.VITE_APP_URL ?? "http://localhost:5137";

export const WEB_URL = import.meta.env.VITE_WEB_URL ?? "http://localhost:3000";

export const DOCS_URL =
  import.meta.env.VITE_DOCS_URL ?? "http://localhost:3000";

export const PAYPAL_CLIENT_ID = import.meta.env.VITE_PAYPAL_CLIENT_ID;
export const PAYMENT_SUCCESS_MESSAGE = "Payment successful";
export const DOWNGRADE_SUCCESS_MESSAGE = "Downgrade successful";
export const DISCOUNT_SUCCESS_MESSAGE =
  "Discount activated, change your plan to enjoy your lower price";

export const REGIONS = ["us-east-1"];
export const ENVS = ["production"];

export const DEPLOY_BASE_DOMAIN = "vibedeploy.dev";
